import { makeStyles } from 'tss-react/mui';

export const useDocLinkBlockStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    paddingTop: theme.spacing(0.25),
  },
  toggle: {
    display: 'inline-flex',
    alignSelf: 'flex-start',
    alignItems: 'center',
    gap: theme.spacing(0.25),
    padding: theme.spacing(0.25, 0.75),
    border: 'none',
    background: 'none',
    color: theme.palette.text.secondary,
    cursor: 'pointer',
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(0.5),
  },
  link: {
    display: 'inline-flex',
    flexShrink: 0,
    textDecoration: 'none',
    cursor: 'pointer',
  },
  chip: {
    flexShrink: 0,
    paddingInline: theme.spacing(0.75),
    color: theme.palette.text.secondary,
    boxShadow: `inset 0 0 0 0.5px ${theme.palette.custom.border.primary}`,
    '& .MuiChip-label': {
      paddingInline: 0,
    },
    '& .MuiChip-icon': {
      marginLeft: 0,
      marginRight: theme.spacing(0.5),
      color: theme.palette.accent.light,
    },
  },
}));
